export default {
  vrtTokenTextField: 'convert-vrt-vrt-token-text-field',
  xvsTokenTextField: 'convert-vrt-xvs-token-text-field',
};
